import comp from "./LockOverlay";
export default comp;
